import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { SetColorOperation } from '../Operations/set-color-operation';
import { TorchOperation } from '../Operations/torch-operation';
import { FlashTypes } from '../operation-types';
import { ScreenStrobeOperation } from '../Operations/screen-strobe-operation';

export class ScreenStrobeSegment extends LightShowSegment {
  static fadeInDuration = 200;
  public colors: string[];

  public init() {
    this.color = 'blue';
    this.minDuration = ScreenStrobeSegment.fadeInDuration;
    this.enableSegmentGrips = true;
  }

  public addOperations(operations: LightShowOperation[]) {
    operations.push(new ScreenStrobeOperation(this.position, this.duration, this.colors));
  }
}